import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAccrualPolicyRequestSchema,
  TGetAccrualPolicyResponseSchema,
} from "./getAccrualPolicy.schema";

export const getAccrualPolicy = (axios: IAxiosInstance) => {
  return async ({ companyID, id }: TGetAccrualPolicyRequestSchema) => {
    const { data } = await axios.noRetry.get<
      IApiResponse<TGetAccrualPolicyResponseSchema>
    >(`/accrual-policies/${id}`, { params: { companyID } });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
